import { Delete, Add } from "@mui/icons-material";
import {
    Box,
    Typography,
    Stack,
    TextField,
    IconButton,
    Button,
} from "@mui/material";

type IngredientRow = {
    id: number;
    text: string;
};

interface RecipeIngredientsSectionProps {
    ingredients: IngredientRow[];
    onAddRow: () => void;
    onChangeRow: (id: number, value: string) => void;
    onRemoveRow: (id: number) => void;
}

export default function RecipeIngredientsSection({
    ingredients,
    onAddRow,
    onChangeRow,
    onRemoveRow,
}: RecipeIngredientsSectionProps) {
    return (
        <Box>
            <Typography variant="h6" fontWeight={600} gutterBottom>
                Ingredients
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                Add each ingredient as a separate line (e.g. "2 cups flour").
            </Typography>

            <Stack spacing={1.5}>
                {ingredients.map((row) => (
                    <Stack
                        key={row.id}
                        direction="row"
                        spacing={1}
                        alignItems="center"
                    >
                        <TextField
                            label="Ingredient"
                            size="small"
                            fullWidth
                            value={row.text}
                            onChange={(e) =>
                                onChangeRow(row.id, e.target.value)
                            }
                            placeholder="e.g. 2 cups flour"
                        />

                        <IconButton
                            size="small"
                            color="error"
                            onClick={() => onRemoveRow(row.id)}
                            disabled={ingredients.length === 1}
                        >
                            <Delete fontSize="small" />
                        </IconButton>
                    </Stack>
                ))}
            </Stack>

            <Box sx={{ mt: 2 }}>
                <Button
                    startIcon={<Add />}
                    size="small"
                    variant="outlined"
                    onClick={onAddRow}
                >
                    Add ingredient
                </Button>
            </Box>
        </Box>
    );
}
